import {inject, Injectable} from '@angular/core';
import * as signalR from '@microsoft/signalr';
import {SocketUtils} from "../../helpers";
import {AuthFacade} from "../../../auth/facade/auth.facade";
import {FeatureToggleService} from "../feature-toggle.service";

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private static hubConnection: signalR.HubConnection | null = null;
  private static baseUrl = ''

  constructor(private authFacade: AuthFacade){
     FeatureToggleService.features.subscribe(res => {
       SignalRService.baseUrl = res["sseBaseUrl"];
     })
  }
  public stopConnection() {
    if (SignalRService.hubConnection) {
      SignalRService.hubConnection.stop()
        .then(() =>{
          SignalRService.hubConnection = null;
        // console.log('SignalR Connection stopped');
        })
        .catch(err => {
          console.error('Error stopping SignalR connection: ' + err);
        });
    }
  }
  public startConnection() {
    const user = JSON.parse(this.authFacade.getLocalStorageData('userData'));
    SignalRService.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(SignalRService.baseUrl, {
        accessTokenFactory: () => user?.accessToken,
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    SignalRService.hubConnection
      .start()
      .then(() => {
        // console.log('SignalR Connection started');
        SignalRService.addMessageListener();
      })
      .catch(err => {
        console.log('Error establishing SignalR connection: ' + err);
      });
  }

  private static addMessageListener() {
    SignalRService.hubConnection.on('ReceiveMessage', (response: any) => {
      // console.log('response: ', response);
      SocketUtils.sendNewEventByActionName(response?.actionKey, response?.payload);
    });
  }

  public sendMessage = (user: string, message: string) => {
    SignalRService.hubConnection.invoke('SendMessage', user, message)
      .catch(err => {
        console.error(err);
      });
  }
}
